import type { LangCode } from '@learnforge/i18n';
import { en } from './en';
import { nl } from './nl';
import { ro } from './ro';
import type { ProbKey } from './keys';

export const locales = {
  en,
  nl: nl as Record<ProbKey, string>,
  ro: ro as Record<ProbKey, string>,
} as const satisfies Partial<Record<LangCode, Record<ProbKey, string>>> & {
  en: Record<ProbKey, string>;
};
export type { ProbKey } from './keys';
